import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';
import { IParams } from '../model/http';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  private readonly urlAllTickets = `${environment.baseURL}/ticket/all`;
  private readonly urlTicket = `${environment.baseURL}/ticket`;
  private readonly urlMessage = `${environment.baseURL}/ticket/message`;


  constructor(
    private readonly http: HttpClient,
  ) { }

  public addTicket(params: any) {
    return this.http.post<any>(this.urlTicket, params )
      .pipe(map(v => v.data));
  }

  public sendMessage(params: any) {
    return this.http.post<any>(this.urlMessage, params )
      .pipe(map(v => v.data));
  }

  public getAllTickets(params: any) {
    return this.http.get<any>(this.urlAllTickets, { params } )
      .pipe(map(v => v.data));
  }

  public getTicket(params: any) {
    return this.http.get<any>(this.urlTicket, { params: { id: params } } )
      .pipe(map(v => v.data));
  }

  public getMessageTicket(params: any) {
    return this.http.get<any>(this.urlMessage, { params } )
      .pipe(map(v => v.data));
  }
}
